import {NgModule} from '@angular/core';
import {FormDefinitionModule} from "./definition/formDefinition.module";
import {FormFormModule} from "./form/formForm.module";

@NgModule({
    imports: [
        FormDefinitionModule,
        FormFormModule
    ]
})
export class FormModule {
}
